export default [{
    path: '/node/superNode',
    name: 'superNode',
    meta: {
        index: 15
    },
    component: () => import('@/views/node/superNode.vue')
}]
